import { Combobox } from "components/DesignSystem/Combobox/Combobox";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useFormikContext } from "formik";
import { useGetAllTaxCodeQuery } from "store/apis/taxCalculator";
import { TaxCode } from "types/Models/taxCalculate";

type SalesTaxCodeComboboxProps = {
  name: string;
  label?: string;
  isDisabled?: boolean;
  onSelect?: (taxCode: TaxCode | null) => void;
};

export const SalesTaxCodeCombobox = ({
  name,
  label = "Product Tax Category",
  isDisabled,
  onSelect,
}: SalesTaxCodeComboboxProps) => {
  const entityId = useCurrentEntityId();

  const { data: taxCodes = [], isLoading } = useGetAllTaxCodeQuery(
    { entityId },
    { skip: !entityId }
  );

  const { values, setFieldValue } = useFormikContext<Record<string, string>>();

  const options = taxCodes.map(({ uuid, description }) => ({
    label: description,
    value: uuid,
  }));

  const selectedOption = options.find((opt) => opt.value === values[name]);

  return (
    <Combobox
      label={label}
      menuPlacement="bottom"
      placeholder="Select"
      menuPortalTarget={document.body}
      name={name}
      options={options}
      value={selectedOption || null}
      onChange={(option) => {
        if (option instanceof Array) return;
        setFieldValue(name, option?.value || null);
        const selectedTaxCode = taxCodes.find((t) => t.uuid === option?.value);
        onSelect?.(selectedTaxCode || null);
      }}
      isLoading={isLoading}
      isClearable={true}
      isDisabled={isDisabled}
    />
  );
};
